import React from 'react';
import { Grid } from '@packages/ui-kit/core/grid';
import classnames from 'classnames';
import styles from '../../styles/components/property-stats.module.scss';
import { AffiliateIcon } from '../icons/affiliate-icon';

export const PropertyStat = React.memo(({ name, value, label, handleClick }) => {
  return (
    <div className={styles['item-wrapper']}>
      <div className={classnames(styles.item, { [styles.pointer]: !!handleClick })} onClick={handleClick}>
        <AffiliateIcon name={name} className={styles.icon} />
        {value && <span className={styles.value}>{value}</span>}
        {label && <span className={styles.label}>{label}</span>}
      </div>
    </div>
  );
});

export const PropertyStats = React.memo(({ children }) => {
  return (
    <Grid className={styles.container} fill>
      {children}
    </Grid>
  );
});
